import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChatStyles from '../../Chat.module.css';
import { useDispatch } from 'react-redux';

const SelectedGroup = ({ data, setShowGroupInfoMoal, requestVideoCallToSelectedUser }) => {
  const { t } = useTranslation();
  const { chatUserLoading, selectedNewUser, selectedUser, groupName, setGroupName } = data;

  useEffect(() => {
    if (selectedNewUser) {
      setGroupName(selectedUser.name, 'namemeee');
    }
  }, [selectedNewUser]);

  return (
    <div className={ChatStyles.chatBox_user}>
      <div className={ChatStyles.chatBox_user_data}>
        <div className={ChatStyles.chatLists_user_imageBox}>
          <img src='/assets/icon-group-logo.jpg' alt='User' className={ChatStyles.chatLists_user_image} />
        </div>
        <div>
          <h3 className={ChatStyles.chatLists_user_name}>{groupName}</h3>
        </div>
      </div>

      {!chatUserLoading && (
        <div className={ChatStyles.chatBox_user_right_container} style={{ gap: '0.4rem' }}>
          {/* Video calling button */}
          <button onClick={() => requestVideoCallToSelectedUser(selectedUser)} className={ChatStyles.video_call_button} title={t('screens.chat.startGroupVideoCall')}>
            <svg>
              <use xlinkHref={`/assets/sprite.svg#icon-video-call`} />
            </svg>
          </button>

          <button onClick={() => setShowGroupInfoMoal(true)} className={ChatStyles.button_with_popup}>
            <svg style={{ height: '1.5rem', width: '1.5rem' }}>
              <use xlinkHref={`/assets/sprite.svg#icon-info-with-circle`} />
            </svg>
            <p>{t('screens.chat.groupInfo')}</p>
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectedGroup;
